// Environment variables utility
// This helps with type safety and default values

// IMPORTANT: For static exports with token substitution:
// - Build-time: Use #{TOKEN_*}# placeholders that get baked into the bundle
// - Release-time: Replace these tokens with actual values in the release pipeline

// Helper to access Vite environment variables without TypeScript complaints
const getEnv = (key: string): string => (import.meta as any).env?.[key] || ""

// Log environment variables for debugging
if (typeof window !== "undefined") {
  console.log("Client-side environment variables:")
  console.log("VITE_API_URL:", getEnv("VITE_API_URL"))
  console.log("VITE_ADMIN_SERVICE_API_ENDPOINT:", getEnv("VITE_ADMIN_SERVICE_API_ENDPOINT"))
  console.log("VITE_ENGAGEMENT_API_URL:", getEnv("VITE_ENGAGEMENT_API_URL"))
  console.log("VITE_REPORTS_API_URL:", getEnv("VITE_REPORTS_API_URL"))
  console.log("VITE_PEOPLE_API_URL:", getEnv("VITE_PEOPLE_API_URL"))
  console.log("VITE_ORGANIZATION_API_URL:", getEnv("VITE_ORGANIZATION_API_URL"))
  console.log("VITE_AUDIT_API_URL:", getEnv("VITE_AUDIT_API_URL"))
  console.log("VITE_USE_MOCK_DATA:", getEnv("VITE_USE_MOCK_DATA"))
  console.log("VITE_BASE_PATH:", getEnv("VITE_BASE_PATH"))
  console.log("VITE_BUILD_ENV:", getEnv("VITE_BUILD_ENV"))
}

// Application environment variables
// Values must be provided via environment variables (e.g., .env.ci file)
export const env = {
  // API URL for backend services
  apiUrl: getEnv("VITE_API_URL"),

  // Admin Service API Endpoint
  adminServiceApiEndpoint: getEnv("VITE_ADMIN_SERVICE_API_ENDPOINT"),

  // Engagement API URL
  engagementApiUrl: getEnv("VITE_ENGAGEMENT_API_URL"),

  // Reports API URL
  reportsApiUrl: getEnv("VITE_REPORTS_API_URL"),

  // People API URL
  peopleApiUrl: getEnv("VITE_PEOPLE_API_URL"),

  // Organization API URL
  organizationApiUrl: getEnv("VITE_ORGANIZATION_API_URL"),

  // Audit API URL
  auditApiUrl: getEnv("VITE_AUDIT_API_URL"),

  // Whether to use mock data instead of real API calls
  useMockData: getEnv("VITE_USE_MOCK_DATA"),

  // Build environment
  buildEnv: getEnv("VITE_BUILD_ENV"),

  // Base path
  basePath: getEnv("VITE_BASE_PATH"),

  // Pipeline build id — baked in at build time to force new file hashes (cache busting)
  buildId: getEnv("VITE_BUILD_ID") || "local",
}

// Log the final env object for debugging
if (typeof window !== "undefined") {
  console.log("Final env object:", env)
}
